import { useStoreUpdater, useFormUpdater } from 'hx-wizard';
/**
 * This hook is used to sync a form with the redux store.
 *
 * @param form The form to sync with the store
 * @param storeFormIndex The index of the form in the store
 * @param updateAction The action to update the store with the form
 * @param extraWatchFields This is needed because react-hook-form doesn't watch nested fields properly, so they need to be specified for now
 *
 * @example
 * import { useSyncFormWithStore } from 'hx-wizard';
 *
 * export const [form, updateForm] = createSimpleStore('myForm');
 *
 * const form = useForm();
 * useStoreUpdater(form, ['myForm'], updateForm);
 *
 */
export var useSyncFormWithStore = function (form, storeFormIndex, updateAction, extraWatchFields) {
    useStoreUpdater(form, updateAction, extraWatchFields);
    useFormUpdater(form, storeFormIndex);
};
